module.exports = __webpack_public_path__ + "static/media/antibodies.a566f52b.jpg";